module.exports = __webpack_public_path__ + "static/media/README.e17b4d8b.md";